import { ordersMockTable } from 'mocks'
import { Navigation, OrdersTable, DashboardTable, CasesModal } from 'components'
import { useTranslation } from 'react-i18next'
import { orders } from '@/api'

export const Dashboard = () => {
  const { t } = useTranslation()
  return (
    <>
      <Navigation />
      <DashboardTable
        title={t('dashboard.title')}
        type="Order"
        api={orders}
        mockTable={ordersMockTable}
        CreateComponent={CasesModal}
        TableComponent={OrdersTable}
      />
    </>
  )
}

export default Dashboard
